export default __webpack_public_path__ + "static/media/banner.fe9ae64e.jpeg";